import * as React from 'react';

import type { AdminSignedStatusDto } from '@/api/legal-admin-client';
import { Badge } from '@/components/ui/badge';

// =============================================================================
// cgu-signature-status.tsx — Rendu partagé du statut « Signature CGU » (S5bis).
// =============================================================================
// Composé DANS LE FRONT à partir du statut admin par SIRET (useCguSignedStatus,
// endpoint legal cross-fournisseur) mergé avec une ligne fournisseur (supplier-
// reference). Réutilisé par A-03 (colonne liste) et A-04 (champ fiche).
//
// Trois états (l'autorité = API ; le front ne fait que rendre) :
//   - status absent (SIRET jamais signataire)        → « — » (différé-visible, jamais inventé).
//   - status.hasSigned === true                      → « Signée » (version courante).
//   - status.hasSigned === false + signedVersionId   → T-06 « À re-signer » (version antérieure).
//
// WCAG 2.1 AA : le LIBELLÉ texte porte l'information ; le Badge n'est qu'un renfort couleur.

export interface CguSignatureCellProps {
  /** Statut du SIRET (undefined = absent de la map ⇒ jamais signataire). */
  readonly status: AdminSignedStatusDto | undefined;
}

/** Cellule/champ de statut de signature CGU (libellé + badge de renfort). */
export function CguSignatureCell({ status }: CguSignatureCellProps): React.JSX.Element {
  if (status === undefined) {
    // SIRET jamais signataire : marqueur « — » (aucune valeur fabriquée).
    return (
      <span aria-label="Aucune signature enregistrée" className="text-muted-foreground">
        —
      </span>
    );
  }
  if (status.hasSigned) {
    return <Badge variant="default">Signée</Badge>;
  }
  // T-06 : a signé une version ANTÉRIEURE → re-signature requise pour la version courante.
  return <Badge variant="outline">À re-signer (version antérieure)</Badge>;
}
